import React from "react";
import "./carousel-desk-header.scss";
import useNavigateWithSearch from "../../../../hooks/useNavigateWitchSearch";
import IconArrow from "../../JSXIcons/IconArrow";
import CusButton from "../../custom_button/CusButton";
import DeskTitle from "../../desk_title/DeskTitle";
import useGetIconByTitle from "../../../../hooks/other/useGetIconByTitle";

export default function CarouselDeskHeader({
  title,
  showAllLink,
  sliderRef,
  manyLength,
  slidesToShow
}) {
  const navigate = useNavigateWithSearch();

  const onShowAll = () => {
    if (showAllLink) navigate(`${showAllLink}`);
  };

  const onPrevClick = () => {
    const swiper = sliderRef.current;
    if (swiper && swiper.realIndex != null) {
      const total = swiper.slides.length;
      const current = swiper.realIndex;
      const prev = (current - slidesToShow + total) % total;
      swiper.slideToLoop(prev);
    }
  };

  const onNextClick = () => {
    const swiper = sliderRef.current;

    if (swiper && swiper.activeIndex != null) {
      const currentIndex = swiper.realIndex;
      const nextIndex = (currentIndex + slidesToShow) % swiper.slides.length;
      swiper.slideToLoop(nextIndex);
    }
  };

  const iconTitle = useGetIconByTitle(title);

  return (
    <div className="carousel-desk__header">
      <DeskTitle iconTitle={iconTitle} title={title} />
      <div className="carousel-desk__header__right">
        <CusButton color="custom" className="show-all" text="Show all" onClick={onShowAll} />
        <div className="carousel-desk__controls">
          <button
            disabled={!manyLength}
            className="carousel-desk__controls__prev"
            onClick={onPrevClick}>
            <IconArrow className="rotate90" />
          </button>
          <button
            disabled={!manyLength}
            className="carousel-desk__controls__next"
            onClick={onNextClick}>
            <IconArrow className="rotate270" />
          </button>
        </div>
      </div>
    </div>
  );
}
